import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppLayout from "./components/layout/AppLayout";
import AccessDenied from "./pages/AccessDenied";
import Dashboard from "./pages/Dashboard";
import BusinessIntelligence from "./pages/BusinessIntelligence";
import HubIntelligence from "./pages/HubIntelligence";
import FactoryIntelligence from "./pages/FactoryIntelligence";
import CustomerIntelligence from "./pages/CustomerIntelligence";
import QualitySLA from "./pages/QualitySLA";
import AIControlCenter from "./pages/AIControlCenter";
import KnowledgeBase from "./pages/KnowledgeBase";
import AskYourBusiness from "./pages/AskYourBusiness";
import InsightsAlerts from "./pages/InsightsAlerts";
import SettingsPage from "./pages/Settings";

function Protected() {
  const { user } = useAuth();
  if (user === null)
    return <div className="min-h-screen grid place-items-center text-slate-400 text-sm">Loading…</div>;
  if (user === false) return <AccessDenied />;
  return <Outlet />;
}

function RoleHome() {
  const { user } = useAuth();
  if (user?.role === "operations") {
    return <Navigate to="/ai/history" replace />;
  }
  return <Dashboard />;
}

function SuperAdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role === "operations") {
    return <Navigate to="/ai/history" replace />;
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/login" element={<AccessDenied />} />
          <Route element={<Protected />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<RoleHome />} />
              <Route path="/ai/:tab?" element={<AIControlCenter />} />

              {/* Super-Admin only routes */}
              <Route path="/bi/:tab?" element={<SuperAdminOnly><BusinessIntelligence /></SuperAdminOnly>} />
              <Route path="/hubs/:tab?" element={<SuperAdminOnly><HubIntelligence /></SuperAdminOnly>} />
              <Route path="/factory/:tab?" element={<SuperAdminOnly><FactoryIntelligence /></SuperAdminOnly>} />
              <Route path="/customers/:tab?" element={<SuperAdminOnly><CustomerIntelligence /></SuperAdminOnly>} />
              <Route path="/quality/:tab?" element={<SuperAdminOnly><QualitySLA /></SuperAdminOnly>} />
              <Route path="/kb/:tab?" element={<SuperAdminOnly><KnowledgeBase /></SuperAdminOnly>} />
              <Route path="/ask" element={<SuperAdminOnly><AskYourBusiness /></SuperAdminOnly>} />
              <Route path="/insights" element={<SuperAdminOnly><InsightsAlerts /></SuperAdminOnly>} />
              <Route path="/settings" element={<SuperAdminOnly><SettingsPage /></SuperAdminOnly>} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

